import {
  Icon,
  Button,
  Collapse,
  CollapseItem,
  Dialog,
  DropdownMenu,
  DropdownItem,
  List,
  Popup,
  RadioGroup,
  Radio,
  Search,
  Sticky,
  Toast,
  Loading,
  NavBar,
  CountDown,
  Lazyload,
  Swipe,
  SwipeItem,
  Step,
  Steps,
  Overlay,
  Progress,
} from '@51job/vant';

Toast.allowMultiple();
export default {
  install(Vue) {
    Vue.use(Icon)
      .use(Button)
      .use(Collapse)
      .use(CollapseItem)
      .use(Dialog)
      .use(DropdownMenu)
      .use(DropdownItem)
      .use(List)
      .use(Popup)
      .use(RadioGroup)
      .use(Radio)
      .use(Search)
      .use(Sticky)
      .use(Toast)
      .use(Loading)
      .use(NavBar)
      .use(CountDown)
      .use(Swipe)
      .use(SwipeItem)
      .use(Step)
      .use(Steps)
      .use(Overlay)
      .use(Progress)
      .use(Lazyload);
    Vue.prototype.$toast = Toast;
  },
};
